<template>
  <div v-if="data.length > itemsPerPage" class="mt-16 flex justify-center">
    <!-- <button
      class="p-1"
      :disabled="currentIndex <= 0"
      aria-label="Vorherige Seite"
      @click="paginate(currentIndex - 1)"
    >
      <IconChevron class="h-7 -rotate-90" />
    </button> -->

    <div class="relative">
      <!-- Floating Background -->
      <div
        class="absolute aspect-square size-10 bg-white"
        :style="{
          left: `${currentIndex * 2.5}rem`,
          transition: 'left 0.3s',
        }"
      />

      <!-- Buttons -->
      <ul class="relative flex flex-wrap">
        <li v-for="(page, index) in pages" :key="index" class="">
          <button
            :id="`pagination-button-${index}`"
            type="button"
            class="flex size-10 items-center justify-center rounded-full typo-label-md"
            :class="{ 'text-gibb-text': currentIndex === index }"
            :aria-label="`Springe zu Seite ${index + 1}`"
            @click="paginate(index)"
          >
            {{ index + 1 }}
          </button>
        </li>
      </ul>
    </div>
    <AppLink
      v-if="currentIndex < pages.length - 1"
      type="button"
      class="group ml-11 flex items-center gap-3 typo-button-md"
      :aria-label="$t('next')"
      show-link-arrow=""
      @click="paginate(currentIndex + 1)"
    >
      {{ $t('next') }}
    </AppLink>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  data: { type: Array, required: true },
  itemsPerPage: { type: Number, default: 16 },
  scrollToId: { type: String, default: '' },
  shouldScroll: { type: Boolean, default: false },
})

const route = useRoute()
const params = useUrlSearchParams('history')

// Get the initial index from the query
let initialIndex = parseInt(route.query[props.scrollToId]) || 0

// Clamp the initial index to the number of pages
initialIndex = Math.max(
  0,
  Math.min(
    initialIndex,
    Math.max(0, Math.ceil(props.data.length / props.itemsPerPage) - 1)
  )
)
const currentIndex = ref(initialIndex)

const emit = defineEmits(['update'])

// Chunk the data into pages
const pages = computed(() => {
  if (!Array.isArray(props.data) || props.data.length === 0) {
    return []
  }

  const chunks = []
  for (let i = 0; i < props.data.length; i += props.itemsPerPage) {
    chunks.push(props.data.slice(i, i + props.itemsPerPage))
  }
  return chunks
})

paginate(currentIndex.value)

watch(
  () => props.data,
  async () => {
    await nextTick()
    paginate(0)
  }
)

function paginate(index) {
  if (index < 0 || index >= pages.value.length) {
    emit('update', [])
    return
  }

  if (props.shouldScroll && props.scrollToId && process.client) {
    scrollToElement(props.scrollToId)
  }

  currentIndex.value = index
  emit('update', pages.value[index])

  // Set the query to the URL
  params[props.scrollToId] = currentIndex.value
}

function scrollToElement(elementId: string) {
  const element = document.getElementById(elementId)

  if (!element) {
    return
  }

  const headerOffset = 250
  const elementPosition = element.offsetTop
  const offsetPosition = elementPosition - headerOffset

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  })
}
</script>
